import validate from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/middleware/auth.ts")
}